export default "__VITE_ASSET__DHd7fk0m__"